import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';

const POLL_INTERVAL_MS = 60_000;

export function useNavCounts() {
  const [patientCounts, setPatientCounts] = useState({ toContact: 0, inProgress: 0, recovered: 0 });
  const [activeCampaigns, setActiveCampaigns] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchCounts = useCallback(async () => {
    try {
      const [navCounts, campaignsRes] = await Promise.all([
        api.getNavCounts(),
        api.getCampaigns(),
      ]);
      setPatientCounts(navCounts);
      const campaigns = campaignsRes.campaigns || campaignsRes || [];
      setActiveCampaigns(campaigns.filter(c => c.status === 'active').length);
    } catch (err) {
      console.error('Failed to fetch nav counts:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCounts();

    const interval = setInterval(fetchCounts, POLL_INTERVAL_MS);

    const handleFocus = () => fetchCounts();
    window.addEventListener('focus', handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', handleFocus);
    };
  }, [fetchCounts]);

  return { patientCounts, activeCampaigns, loading };
}
